import { t } from "@web-monorepo/i18n/macro";
import { DDSTextarea } from "@web-monorepo/dds";
import { ToolPayload } from "src/pods/toolkitData/components/EditableSetup";

export type TodayEditProps = {
  onEdit: (payload: ToolPayload, disabled?: boolean) => void;
  payload: ToolPayload;
};

export default function TodayEdit({ onEdit, payload }: TodayEditProps) {
  return (
    <DDSTextarea
      data-name="today_edit:textarea"
      label={t`Share daily announcements, a welcome message, morning work, etc.`}
      rows={3}
      onChange={(text) => onEdit({ text }, !text)}
      value={payload ? payload.text : ""}
    />
  );
}
